import { useState } from 'react';
import { Gauge, MessageSquare, CheckCircle2 } from 'lucide-react';

function ComingSoon() {
  const [isInterested, setIsInterested] = useState(false);

  const handleInterest = () => {
    console.log({ serviceInterest: ['AI Maturity Index', 'Sentiment Index'] });
    setIsInterested(true);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold text-text mb-4">
          New Features Coming Soon
        </h1>
        <h2 className="text-2xl text-text-secondary mb-6">
          Quantifaid AI News & Sentiment Indexes—launching soon
        </h2>
        <p className="text-lg text-text-secondary max-w-2xl mx-auto">
          Stay ahead with real-time AI news aggregation and measure social sentiment around AI tools and trends.
        </p>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
        {/* AI News Card */}
        <div className="bg-background-light rounded-xl border border-primary/20 p-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-primary/10 p-3 rounded-lg">
              <MessageSquare className="text-primary" size={24} />
            </div>
            <h3 className="text-2xl font-semibold text-text">AI News</h3>
          </div>
          <p className="text-text-secondary mb-6">
            Stay ahead with curated, real-time news and insights on AI trends, breakthroughs, and industry impact—aggregated from top sources worldwide.
          </p>
          <ul className="space-y-3">
            <li className="flex items-center gap-2 text-text-secondary">
              <CheckCircle2 className="text-primary" size={16} />
              Curated AI news from trusted sources
            </li>
            <li className="flex items-center gap-2 text-text-secondary">
              <CheckCircle2 className="text-primary" size={16} />
              Daily updates on AI breakthroughs & policy
            </li>
            <li className="flex items-center gap-2 text-text-secondary">
              <CheckCircle2 className="text-primary" size={16} />
              Industry impact and trend analysis
            </li>
          </ul>
        </div>

        {/* Sentiment Index Card */}
        <div className="bg-background-light rounded-xl border border-primary/20 p-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-primary/10 p-3 rounded-lg">
              <MessageSquare className="text-primary" size={24} />
            </div>
            <h3 className="text-2xl font-semibold text-text">Sentiment Index</h3>
          </div>
          <p className="text-text-secondary mb-6">
            Real-time social sentiment scores for AI tools (ChatGPT, Manus, and more) from Twitter, Reddit, news, and forums.
          </p>
          <ul className="space-y-3">
            <li className="flex items-center gap-2 text-text-secondary">
              <CheckCircle2 className="text-primary" size={16} />
              Measure public trust & hype
            </li>
            <li className="flex items-center gap-2 text-text-secondary">
              <CheckCircle2 className="text-primary" size={16} />
              Competitive tool benchmarking
            </li>
            <li className="flex items-center gap-2 text-text-secondary">
              <CheckCircle2 className="text-primary" size={16} />
              Early reputational risk warnings
            </li>
          </ul>
        </div>
      </div>

      {/* CTA Button */}
      <div className="text-center">
        {!isInterested ? (
          <button
            onClick={handleInterest}
            className="bg-primary text-background px-8 py-3 rounded-lg hover:bg-primary-light transition-colors text-lg font-medium"
          >
            Notify me when live
          </button>
        ) : (
          <p className="text-text-secondary text-lg">
            Thanks! We'll notify you as soon as these indexes launch.
          </p>
        )}
      </div>
    </div>
  );
}

export default ComingSoon; 